import React, { useState } from "react";
import { ArrowRight, Calendar } from "lucide-react";
import DemoRequestModal from "./DemoRequestModal";

const CTA = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  return (
    <>
      <section className="relative py-12 bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            {/* Main CTA */}
            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-4">
              Ready to Transform Your
              <span className="block">Security Program?</span>
            </h2>
            
            <p className="text-lg lg:text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
              Join forward-thinking security teams who are already using AI to eliminate alert fatigue and protect their organizations
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
              <button 
                onClick={() => setIsDemoModalOpen(true)}
                className="inline-flex items-center justify-center bg-white text-blue-600 hover:bg-gray-50 px-8 py-4 text-lg font-semibold rounded-md transition-all duration-200 transform hover:scale-105"
              >
                <Calendar size={20} className="mr-2" />
                Request Demo
                <ArrowRight size={20} className="ml-2" />
              </button>
            </div>

          {/* Value Props */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-1">No credit card required</div>
              <div className="text-blue-100 text-sm">30-day free trial</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-1">Enterprise ready</div>
              <div className="text-blue-100 text-sm">Scalable for teams of all sizes</div>
            </div>
          </div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-20 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 right-20 w-48 h-48 bg-indigo-400/20 rounded-full blur-xl"></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-blue-300/15 rounded-full blur-lg"></div>
      </div>
    </section>

    {/* Demo Request Modal */}
    <DemoRequestModal 
      isOpen={isDemoModalOpen} 
      onClose={() => setIsDemoModalOpen(false)} 
    />
    </>
  );
};

export default CTA;
